import request from 'config/axios'

const URL = '/transfer-security/accounts'
const SEND_TRANSFER_SECURITY = '/transfer-security'

export const getTransferSecurity = () => request.get(URL)
export const sendTransferSecurity = payload => request.post(SEND_TRANSFER_SECURITY, payload)
